import normalizeStyleParamProperties from './normalizeStyleParamProperties';

import { IStyleParams } from '@wix/podcasts-common/dist/style-params';
import { ISettings } from '../../types';
import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';
import { mergeMobileStyles } from '@wix/podcasts-common/dist/settings/mobile';

function settingsReady(params: IStyleParams): boolean {
  const settings = params.fonts.settings;
  return Boolean(settings);
}

function styleParamsToSettings(
  params: IStyleParams,
  deviceType: TPADeviceType,
): ISettings {
  // NOTE: settings is not yet ready
  // NOTE: I suppose this means that user have never been opening settings
  if (!settingsReady(params)) {
    return;
  }

  const deviceSpecificParams =
    deviceType === TPADeviceType.MOBILE ? mergeMobileStyles(params) : params;

  const {
    fonts: { settings: rawSettings, ...rawFonts },
    colors: rawColors,
  } = deviceSpecificParams;

  const fonts = normalizeStyleParamProperties(rawFonts, {
    main: {},
    episode: {},
    common: {},
  });
  const colors = normalizeStyleParamProperties(
    rawColors,
    {
      main: {},
      episode: {},
      common: {},
    },
    (color) => color && color.value,
  );

  return {
    ...rawSettings,
    fonts,
    colors,
  };
}

export default styleParamsToSettings;
